import { ApiService } from './../../../services/apiservice/apiservice.service';
import { ConfigService } from './../../../services/config/config.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { RoutingService } from '../../../services/routing/routing.service';
import { DashboardService } from '../../../pages/dashboard/dashboard.service';
import { LayoutService } from '../../../services/layout.service';

export interface QuickMenuItem {
  menuId: number;
  menuItem: number;
  menuType: string;
  ordinal: number;
  isDefault: boolean;
  label: string;
  parentLabels: string[];
  quickKey: string;
  url: string;
}

@Injectable()
export class QuickMenuService {
  private _quickMenuItems = new BehaviorSubject<QuickMenuItem[]>(null);

  quickMenuItems$ = this._quickMenuItems.asObservable();

  constructor(
    private _configService: ConfigService,
    private _routingService: RoutingService,
    private _layoutService: LayoutService,
    private _dashboardService: DashboardService,
    private _apiService: ApiService,
  ) {}

  loadQuickMenu(): Observable<QuickMenuItem[]> {
    const url = this._configService.agApi + '/quickmenu';
    return this._apiService.get(url).pipe(
      map((response) => {
        if (response?.data && response.status == '200 OK') {
          this._quickMenuItems.next(response.data);
        }
        return response.data;
      }),
    );
  }

  addQuickMenu(data): Observable<any> {
    //TODO How to throw exception so subscribe picks up error
    if (this._quickMenuItems.getValue().length > 9) {
      return throwError('Cannot add more that 10 items to quickmenu. Delete some items');
    }

    const url = this._configService.agApi + '/quickmenu';
    return this._apiService.post(url, data).pipe(
      map((response) => {
        if (response.status != '200 OK') {
          throw Error('Failed to add quick link item');
        }

        this.loadQuickMenu().subscribe();
        return response.data;
      }),
      catchError((error: unknown) => {
        this.loadQuickMenu().subscribe();
        throw Error('Failed to add quick link item');
      }),
    );
  }

  updateQuickMenu(data): Observable<any> {
    const url = this._configService.agApi + '/quickmenu';
    return this._apiService.put(url, data).pipe(
      map((response) => {
        if (response.status != '200 OK') {
          throw Error('Failed to update quick links');
        }

        this.loadQuickMenu().subscribe();
      }),
      catchError((error: unknown) => {
        this.loadQuickMenu().subscribe();
        throw Error('Failed to update quick links');
      }),
    );
  }

  //TODO Convert to proper delete RestFULL endpoint
  deleteQuickMenu(data): Observable<any> {
    const url = this._configService.agApi + '/QuickMenu/DeleteQuickMenu';
    return this._apiService.post(url, data).pipe(
      map((response) => {
        if (response.status != '200 OK') {
          throw Error('Failed to delete quick link item');
        }

        this.loadQuickMenu().subscribe();
        return response.data;
      }),
      catchError((error: unknown) => {
        this.loadQuickMenu().subscribe();
        throw Error('Failed to delete quick link item');
      }),
    );
  }

  hotkey(event: KeyboardEvent | MessageEvent): boolean {
    let key;
    if (event instanceof KeyboardEvent) {
      if (
        event.key == 'F9' ||
        (event.ctrlKey &&
          (event.key == '0' ||
            event.key == '1' ||
            event.key == '2' ||
            event.key == '3' ||
            event.key == '4' ||
            event.key == '5' ||
            event.key == '6' ||
            event.key == '7' ||
            event.key == '8' ||
            event.key == '9' ||
            event.key == 'b' ||
            event.key == 'B' ||
            event.key == 'l' ||
            event.key == 'L'))
      ) {
        key = event.key;
      }
    } else if (event instanceof MessageEvent) {
      const eventName: any = event.data.Event;
      if (typeof eventName == 'string') {
        if (eventName.includes('Ctrl+')) {
          const parts = eventName.split('+');
          key = parts[1];
        } else if (eventName.includes('Numpad')) {
          key = eventName.replace('Numpad', '');
        } else if (eventName.includes('F9')) {
          key = eventName;
        }
      }
    }

    if (!key) {
      return false;
    }

    event.stopPropagation();
    event.preventDefault();

    if (key == 'b' || key == 'B') {
      this._routingService.goToDashboard();
    } else if (key == 'l' || key == 'L') {
      this._dashboardService.popStaffLinksHistory();
    } else if (key == 'F9') {
      this._layoutService.openSideNav({ template: 'quickmenu', position: 'end' });
    } else {
      let offsetKey = parseInt(key) - 1;
      if (offsetKey < 0) {
        offsetKey = 9;
      }

      const item = this._quickMenuItems.value?.find((x) => x.ordinal == offsetKey);
      if (item) {
        this._dashboardService.goToMenuItem(item.menuItem);
      }
    }

    return true;
  }
}
